// Dummy Alerts & Diagnostic Trouble Codes for the demo EV

const dummyAlerts = [
  {
    id: 'P1A08',
    severity: 'warning', // info, warning, critical
    category: 'battery',
    title: 'Temperature Sensor Discrepancy',
    description: 'Battery pack section 2 sensor reading slightly high',
    timestamp: Date.now() - 2 * 60 * 60 * 1000, // 2 hours ago
    status: 'active', // active, resolved, acknowledged
    recommendation: 'Check at next service appointment',
    safeToDrive: true,
    affectedComponent: 'Battery Pack Module 2',
    technicalDetails: {
      sensorId: 'BMS_TEMP_02',
      expectedRange: '20-35°C',
      currentReading: '31.5°C',
      deviation: '+2.8°C from neighbors'
    }
  },
  {
    id: 'U0001',
    severity: 'info',
    category: 'communication',
    title: 'CAN Bus Intermittent',
    description: 'Brief communication dropout detected',
    timestamp: Date.now() - 24 * 60 * 60 * 1000, // Yesterday
    status: 'resolved',
    recommendation: 'Monitor for recurrence',
    safeToDrive: true,
    affectedComponent: 'Communication Network',
    technicalDetails: {
      busId: 'CAN_HIGH',
      dropoutDuration: '0.3 seconds',
      occurrences: 1,
      cause: 'Likely transient EMI'
    }
  }
];

// Additional alert templates for demo scenarios
export const alertTemplates = {
  lowBattery: {
    id: 'P0A0A',
    severity: 'warning',
    category: 'battery',
    title: 'Low Battery Charge',
    description: 'Battery charge below 20%',
    recommendation: 'Charge vehicle soon',
    safeToDrive: true
  },

  highTemp: {
    id: 'P0A0B',
    severity: 'critical',
    category: 'battery',
    title: 'Battery Overtemperature',
    description: 'Battery temperature exceeds safe operating range',
    recommendation: 'Stop and allow to cool. Contact service immediately.',
    safeToDrive: false
  },

  cellImbalance: {
    id: 'P1A09',
    severity: 'warning',
    category: 'battery',
    title: 'Cell Voltage Imbalance',
    description: 'Cell voltage differential exceeds threshold',
    recommendation: 'Schedule battery balancing service',
    safeToDrive: true
  },

  motorOverheat: {
    id: 'P0B0A',
    severity: 'warning',
    category: 'motor',
    title: 'Motor Temperature High',
    description: 'Motor temperature approaching limit',
    recommendation: 'Reduce load and allow cooling',
    safeToDrive: true
  },

  chargingFault: {
    id: 'U0126',
    severity: 'warning',
    category: 'charging',
    title: 'Charging System Fault',
    description: 'Unable to charge at requested rate',
    recommendation: 'Check charger connection and cable',
    safeToDrive: true
  },

  insulationFault: {
    id: 'P0A12',
    severity: 'critical',
    category: 'safety',
    title: 'HV Insulation Fault',
    description: 'High voltage insulation resistance low',
    recommendation: 'DO NOT DRIVE. Contact service immediately.',
    safeToDrive: false
  },

  tyrePressureLow: {
    id: 'C0550',
    severity: 'info',
    category: 'tyres',
    title: 'Tyre Pressure Low',
    description: 'Front left tyre pressure below recommended',
    recommendation: 'Inflate to 2.3 bar',
    safeToDrive: true
  },

  softwareUpdate: {
    id: 'B0001',
    severity: 'info',
    category: 'system',
    title: 'Software Update Available',
    description: 'New firmware version 2.5.0 available',
    recommendation: 'Install at next service or via OTA',
    safeToDrive: true
  }
};

export default dummyAlerts;
